"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
Object.defineProperty(exports, "initializeReporters", {
    enumerable: true,
    get: function() {
        return initializeReporters;
    }
});
const _createReporter = require("./createReporter.js");
async function initializeReporters(logger, options, customReporters = {}) {
    const { reporter } = options;
    // filter out falsy values (e.g. undefined) from the reporter array
    const reporterOptions = (Array.isArray(reporter) ? reporter : [
        reporter
    ]).filter(Boolean);
    if (reporterOptions.length === 0) {
        // "default" is just a dummy name to trigger the default case in createReporter
        reporterOptions.push("default");
    }
    // add profile reporter if --profile is passed
    if (options.profile) {
        reporterOptions.push("profile");
    }
    for (const reporterName of reporterOptions){
        const reporterInstance = await (0, _createReporter.createReporter)(reporterName, options, customReporters);
        logger.addReporter(reporterInstance);
    }
    return logger.reporters;
}
